if($('.id--17').length){
    var linkLogin = $('label[for="login"]').closest('div.form-group').find('a').attr('href')
    $('label[for="login"]').closest('div.form-group').hide()
    $('.cart-header').after('<div class="login-section">Pokud jste registrovaný uživatel, můžete použít <a href="'+linkLogin+'">přihlášení</a> a my automaticky vyplníme vaše údaje.</div>')
    $('label[for="set-registration"]').html('Uložit vyplněné údaje a vytvořit účet <span id="reg-info" class="js-hidden additional-information">(Informace o registraci vám budou zaslány e-mailem)</span>')
}

if($('header#header').length){
    $(document).on('click', '.detail-lista .button, .add-to-cart button', function (e) {
        getCartContent();
    });
    document.addEventListener('ShoptetDOMCartContentLoaded', function() {
        getCartContent();
    });
    $(document).ready(function(){
        if(!$('a[data-target="cart"] .customCount').length){
            $('a[data-target="cart"]').append('<span class="customCount">'+getShoptetDataLayer('cart').length+'</span>')
        }
        else{
            $('a[data-target="cart"] .customCount').html(getShoptetDataLayer('cart').length)
        }
    }) 
    function getCartContent(){
        setTimeout(function(){
            $.get('/action/Cart/GetCartContent/?simple_ajax_cart=1').done(function(data) { 
                console.log(data.code)
                if(data.code = 200){
                    var countLength = $(data.payload.content).find('.cart-widget-product[data-micro="cartItem"]').length
                    console.log(countLength)
                    if(!$('a[data-target="cart"] .customCount').length){
                        $('a[data-target="cart"]').append('<span class="customCount">'+countLength+'</span>')
                    }
                    else{
                        $('a[data-target="cart"] .customCount').html(countLength)
                    }
                   
                }
            })
        }, 100)
        
    }
}